import { Button } from '@frontend/web-react';

export type CloseTaskButtonProps = {
  onClick: () => void;
};

export const CloseTaskButton = ({ onClick }: CloseTaskButtonProps) => {
  return (
    <Button
      accessibilityLabel="Close task"
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="border border-textPrimary rounded-full h-[36px] px-sm bg-trueWhite hover:bg-slate-50"
      leftIconName="IconCheck"
      onClick={onClick}
      size="sm"
    >
      Close Task
    </Button>
  );
};
